const BASE = 'aresLoan-mbBanking.products.loansAndMortgages.productContracting.01_LoanContracting.';

export default {
  TITLE: `${BASE}mbWizard.confirmationTitle`,
  DESCRIPTION_APPROVED_01: `${BASE}mbWizard.confirmationDescription01`,
  DESCRIPTION_APPROVED_02: `${BASE}mbWizard.confirmationDescription02`,
  DESCRIPTION_COUNTEROFFER_01: `${BASE}mbWizard.confirmationDescription03`,
  DESCRIPTION_COUNTEROFFER_02: `${BASE}mbWizard.confirmationDescription04`,
  TIN_LABEL: `${BASE}mbWizard.annualTinLabel`,
  TAE_LABEL: `${BASE}mbWizard.taeLabel`,
  OPENING_FEE_LABEL: `${BASE}mbWizard.openingCommissionLabel`,
  INSTALLMENT_LABEL: `${BASE}mbWizard.monthlyQuotaLabel`,
  TAE_MESSAGE: `${BASE}mbMessage.importantTaeDescription`,
  TOTAL_AMOUNT_LABEL:`${BASE}mbWizard.totalAmountLabel`,
  TOTAL_AMOUNT_TOOLTIP:`${BASE}mbWizard.totalAmountTooltip`,
  PERSONAL_DATA_MESSAGE: `${BASE}mbMessage.importantPersonalDataDescription01`,
  PAYMENT_DAY_TYPE_TITLE: `${BASE}mbWizard.selectQuotaMonthlyPaymentDayLabel`,
  PAYMENT_DAY_TYPE_END_MONTH: `${BASE}mbWizard.quotaMonthlyPaymentDayRadioButton01`,
  PAYMENT_DAY_TYPE_ANNIVERSARY: `${BASE}mbWizard.quotaMonthlyPaymentDayRadioButton02`,
};
